import { createContext, useContext, useState, useEffect } from 'react';
import api from '@/lib/api';

const SettingsContext = createContext({ settings: {}, settingsLoaded: false });

export function SettingsProvider({ children }) {
  const [settings, setSettings] = useState({});
  const [settingsLoaded, setSettingsLoaded] = useState(false);

  useEffect(() => {
    api.get('/site-settings')
      .then(r => {
        setSettings(r.data);
        setSettingsLoaded(true);
      })
      .catch(() => {
        setSettingsLoaded(true);
      });
  }, []);

  return (
    <SettingsContext.Provider value={{ settings, settingsLoaded }}>
      {children}
    </SettingsContext.Provider>
  );
}

export const useSettings = () => useContext(SettingsContext);
